import { render, staticRenderFns } from "./SectionInfo.vue?vue&type=template&id=0c36fcbc&"
import script from "./SectionInfo.vue?vue&type=script&lang=ts&"
export * from "./SectionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SectionInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports